module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5003/images/default-company-avatar.png"